export type AdminV2CreditCalculationMode = 'static' | 'server_quote';

export type AdminV2ClientResolvableCreditFactorKind =
  | 'constant'
  | 'inputCount'
  | 'toolField'
  | 'conditional';

const STATIC_CREDIT_FACTOR_KINDS: ReadonlySet<AdminV2ClientResolvableCreditFactorKind> =
  new Set(['constant', 'inputCount', 'toolField', 'conditional']);

export function isAdminV2ClientResolvableCreditFactorKind(
  kind: string
): kind is AdminV2ClientResolvableCreditFactorKind {
  return STATIC_CREDIT_FACTOR_KINDS.has(
    kind as AdminV2ClientResolvableCreditFactorKind
  );
}

/**
 * A static policy is published with the Workspace Tool runtime and can be
 * evaluated identically in the browser and on the server. Server-owned inputs
 * (provider execution, server metadata, outputs, or registered calculators)
 * remain ineligible for Workspace credit display.
 */
export function resolveAdminV2CreditCalculationMode(policy: {
  terms: Array<{ factors: Array<{ kind: string }> }>;
}): AdminV2CreditCalculationMode {
  return policy.terms.some((term) =>
    term.factors.some(
      (factor) => !isAdminV2ClientResolvableCreditFactorKind(factor.kind)
    )
  )
    ? 'server_quote'
    : 'static';
}
